<script lang="ts">
  import TableFormCell from "@kontextwerk/web-sdk/ui/layout/TableFormCell.svelte"
  import type {
    InboxWorkflowCellProps,
    InboxWorkflowJson,
  } from "@kontextwerk/control-web-frame/inbox-workflow/contract"
  import InboxRowSelectInput from "../../../../../../_shared/_modules/inbox-row-select-input"
  import type { LetterSelectionDraft, LetterSelectionRow } from "../../contract"
  import {
    printRowKey,
    recipientChoiceOptionsForRow,
    recipientChoiceValueForState,
    setRecipientValue,
  } from "../../../../_shared/_logic/print-selection"

  let props: InboxWorkflowCellProps<LetterSelectionRow, LetterSelectionDraft> = $props()

  const printRow = $derived(props.row)
  const state = $derived(props.draft)
  const value = $derived(recipientChoiceValueForState(state))
  const options = $derived(
    recipientChoiceOptionsForRow(printRow).map((option) => ({
      value: option.value,
      label: option.name,
    })),
  )
  const disabled = $derived(
    props.binding.disabled || state.ignored || state.mode === "GENERIC_KLEBEZETTEL",
  )

  const handleChange = (next: string) => {
    const rowId = printRowKey(printRow)
    const updated = setRecipientValue({ [rowId]: state }, printRow, next)
    props.patchDraft(updated[rowId] as unknown as InboxWorkflowJson)
  }
</script>

<TableFormCell>
  {#if printRow.statusLabel === "Datenfehler"}
    <span class="letter-print-empty">—</span>
  {:else}
    <InboxRowSelectInput
      placeholder="Empfänger auswählen"
      {options}
      {value}
      classList="inbox-table-control"
      selectStyle="width: 100%; min-width: 0;"
      {disabled}
      onChange={(next) => handleChange(String(next))}
    />
  {/if}
</TableFormCell>

<style>
  .letter-print-empty {
    color: var(--text-invers-100);
  }
</style>
